var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.5C3.36457 0.5 0 3.86457 0 8C0 12.1354 3.36457 15.5 7.5 15.5C11.6354 15.5 15 12.1354 15 8C15 3.86457 11.6354 0.5 7.5 0.5ZM7.5 14.5625C3.88137 14.5625 0.937504 11.6186 0.937504 8C0.937504 4.38137 3.88137 1.4375 7.5 1.4375C11.1186 1.4375 14.0625 4.38137 14.0625 8C14.0625 11.6186 11.1186 14.5625 7.5 14.5625Z",
    fill: "#000229"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96875 3.3125H7.03125V8.19408L9.98108 11.1439L10.6439 10.4811L7.96875 7.8059V3.3125Z",
    fill: "#000229"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.dd789e8867dbcffaf544051e400241a2.svg";
export { ForwardRef as ReactComponent };